import React, { createContext, useContext, useEffect, useState } from "react";
import { authMe, authLogin, authRegister, authLogout } from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest

  useEffect(() => {
    authMe().then(setUser).catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const u = await authLogin({ email, password });
    setUser(u);
    return u;
  };

  const register = async (name, email, password) => {
    const u = await authRegister({ name, email, password });
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await authLogout(); } catch { /* ignore */ }
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
